import React, { Component } from "react";
import Accordion from "../UI/Accordion";
import TextInput from "../UI/TextInput";

export class Location extends Component {
    continue = (e) => {
        e.preventDefault();

        if (this.props.values.isIncompleteAddress){
            const isValidMovingFromAddress = this.props.validateMovingFromIncompleteAddress();
            if (isValidMovingFromAddress){
                this.props.handleStep2ValidationAfterCompleteAddr();
                this.props.jumpToStep(5);
                return;
            }
            else{
                this.props.handleIncompleteMovingFromAddress();
                return;
            }               
        }

        if (this.props.values.initForm) {
            this.props.handleValidationFields(1);
        }

        if (this.props.values.step1FormValid) {
            this.props.nextStep();
        }

        try {
            if (typeof (ga) === "function") {
                var fields = {
                    hitType: "event",
                    event_category: "onlinebooking",
                    eventAction: "completed Moving From/To",
                    value: "1",
                };

                window.gtag('event', fields.eventAction, fields);
            }
        } catch (err) {
            console.log("Error Logging Google Analytics Event for Step 1 - Online booking");
        }
    };

    previous = (e) => {
        e.preventDefault();
        this.props.prevStep();
    };

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { values, handleChange, updateInputValue } = this.props;

        return (
            <div className="ob-bg">
                <div className="ob-wrapper">
                    <h2 className="ob-h2">{document.getElementById("Step1Title").value}</h2>
                    <Accordion title="Where are you moving from?" open={true}>
                        <TextInput
                            label="Street Address, City, State"
                            required
                            id="movingFromStreet"
                            placeholder="Enter street address"
                            value={values.movingFromStreet}
                            onChange={handleChange("movingFromStreet")}
                            svg="#icon-location"
                            viewBox="0 0 12 16"
                            className="ob-input--66"
                            isGoogleAutoFill
                            validationMessage={values.formErrors.movingFromStreetErrMsg}
                            isValid={(values.movingFromValid)}
                            onPlaceSelected={(selected) => {
                                updateInputValue("movingFromStreet", selected);
                            }}
                        />
                        {/* <div className="panel panel-default">
              <FormErrors fieldName={values.formErrors.movingFromStreet} />
            </div> */}
                        <TextInput
                            label="Unit/Apt/Suite"
                            id="movingFromUnit"
                            placeholder="Enter unit number"
                            value={values.movingFromUnit}
                            onChange={handleChange("movingFromUnit")}
                            className="ob-input--33"
                            isValid={true}
                        />
                    </Accordion>
                    <Accordion title="Where are you moving to?" open={true}>
                        <TextInput
                            label="Street Address, City, State"
                            required
                            id="movingToStreet"
                            placeholder="Enter street address"
                            value={values.movingToStreet}
                            onChange={handleChange("movingToStreet")}
                            svg="#icon-location"
                            viewBox="0 0 12 16"
                            className="ob-input--66"
                            isGoogleAutoFill
                            validationMessage={values.formErrors.movingToStreetErrMsg}
                            isValid={(values.movingToValid)}
                            onPlaceSelected={(selected) => {
                                updateInputValue("movingToStreet", selected);
                            }}
                        />
                        <TextInput
                            label="Unit/Apt/Suite"
                            id="movingToUnit"
                            placeholder="Enter unit number"
                            value={values.movingToUnit}
                            onChange={handleChange("movingToUnit")}
                            className="ob-input--33"
                            isValid={true}
                        />
                    </Accordion>
                    <div className="ob-btn__container">
                        {/* <button className="ob-btn ob-btn--half" onClick={this.previous}>
              Back
            </button> */}
                        <button
                            className="ob-btn ob-btn--half"
                            onClick={this.continue}
                        //disabled={!values.formValid}
                        >
                            {document.getElementById("Step1NextButtonText").value}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default Location;
